(function () {
  function mountMobileMenuV3() {
    var toggle = document.querySelector('.theme-mode-toggle--mobile');
    if (toggle && !toggle.querySelector('.theme-mode-toggle__switch')) {
      toggle.innerHTML =
        '<span class="theme-mode-toggle__label theme-mode-toggle__label--light">LIGHT</span>' +
        '<span class="theme-mode-toggle__switch" aria-hidden="true"><span class="theme-mode-toggle__knob"></span></span>' +
        '<span class="theme-mode-toggle__label theme-mode-toggle__label--dark">DARK</span>';
    }

    var links = Array.prototype.slice.call(document.querySelectorAll('.mobile-nav__link'));
    var caseLink = links.find(function (link) {
      if (link.closest('.mobile-nav__item--case-studies')) return false;
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      return label === 'CASE STUDY 4' || label === 'CASE STUDY 04';
    });

    if (!caseLink) return;

    var item = caseLink.closest('.mobile-nav__item') || caseLink.parentElement;
    if (!item) return;

    item.classList.add('mobile-nav__item--case-studies');
    item.innerHTML =
      '<button class="mobile-nav__link mobile-nav__case-studies-toggle" type="button" aria-expanded="false" aria-controls="mobile-case-studies-v3">CASE STUDIES</button>' +
      '<ul class="mobile-nav__children" id="mobile-case-studies-v3" aria-hidden="true" hidden>' +
        '<li><a class="mobile-nav__child-link" href="/pages/case-study-4-your-life">CASE STUDY 04</a></li>' +
        '<li><a href="/pages/case-study-3-school-of-thought" class="mobile-nav__child-link">CASE STUDY 03</a></li>' +
        '<li><span class="mobile-nav__child-link is-unavailable">CASE STUDY 2.5</span></li>' +
        '<li><span class="mobile-nav__child-link is-unavailable">CASE STUDY 2</span></li>' +
        '<li><span class="mobile-nav__child-link is-unavailable">CASE STUDY 1</span></li>' +
      '</ul>';

    var button = item.querySelector('.mobile-nav__case-studies-toggle');
    var children = item.querySelector('.mobile-nav__children');
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var opening = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      children.setAttribute('aria-hidden', opening ? 'false' : 'true');
      children.hidden = !opening;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountMobileMenuV3);
  } else {
    mountMobileMenuV3();
  }
})();
